export const FLIGNT_NUMBER = 'Flight Number';
export const RECORD_LOCATOR = 'Record Locator';
export const ROUTE = 'Route';

export const types = [FLIGNT_NUMBER, ROUTE];

export const getFsSearchType = (type) => {
  if (type === FLIGNT_NUMBER) return 'flight_number';
  if (type === ROUTE) return 'route';
  return null;
};

export const getFsSearchTypeDefault = (type) => {
  if (type === 'flight_number') return FLIGNT_NUMBER;
  if (type === 'route') return ROUTE;
  return null;
};

export const getUniqueFlightAPIKey = (item) =>
  item.flightNumber + item.departureAirport.fsCode + item.arrivalAirport.fsCode;
